import { render } from "./DurationsManagement.vue?vue&type=template&id=d7b442b0&scoped=true"
import script from "./DurationsManagement.vue?vue&type=script&lang=js"
export * from "./DurationsManagement.vue?vue&type=script&lang=js"

import "./DurationsManagement.vue?vue&type=style&index=0&id=d7b442b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b442b0"]])

export default __exports__